import { Component, OnInit, OnDestroy } from '@angular/core';
import { Params, ActivatedRoute, Router } from '@angular/router';

import { Subscription } from 'rxjs/Subscription';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/map';

import { DateUtils } from '../dateutils.service';

@Component({
    templateUrl: './date.component.html',
    styleUrls: ['./date.component.css']
})
export class DateComponent implements OnInit, OnDestroy {

    date = new Date()

    private oneDay = 1000 * 60 * 60 * 24;
    private navSubs : Subscription

    nextDayUrl : string[] = []
    prevDayUrl : string[] = []

    constructor(public route : ActivatedRoute, public router : Router, private dateutils : DateUtils) {}

    calcNextPrevDays() {
        this.nextDayUrl = this.dateutils.dayUrl(new Date(this.date.getTime() + this.oneDay));
        this.prevDayUrl = this.dateutils.dayUrl(new Date(this.date.getTime() - this.oneDay));
    }

    pageTitle() {
        if (this.dateutils.isToday(this.date)) {
            return "Today";
        } else {
            let dateStr = this.dateutils.dayName(this.date) + ", " + this.date.getDate() + " " + this.dateutils.shortMonthName(this.date);
            if (this.date.getFullYear() == new Date().getFullYear()) {
                return dateStr;
            } else {
                return dateStr + " " + this.date.getFullYear();
            }
        }
    }

    today() {
        return ["/date", "today"];
    }

    ngOnInit() {
        this.navSubs = this.route.params.map((params : Params) => {
            if (params.hasOwnProperty("date")) {
                let date = params["date"]
                if (date === "today") {
                    return new Date();
                }
                return new Date(date);
            } else {
                this.router.navigate(this.dateutils.todayUrl());
            }
            return new Date();
        }).subscribe(newDate => {
            this.date = newDate;
            this.calcNextPrevDays();
        });
    }

    ngOnDestroy() {
        if (this.navSubs) {
            this.navSubs.unsubscribe();
        }
    }
}



// WEBPACK FOOTER //
// /Users/vlad/Projects/done/web/src/app/main/date.component.ts